import { useEffect } from "react";
import { useNavigate } from "react-router";
import Cookies from "js-cookie";

const CookieRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // const hasAuthCookie = document.cookie
    //   .split("; ")
    //   .find((row) =>
    //     row.startsWith(import.meta.env.VITE_PUBLIC_SUNSTAR_GUM_COOKIE_NAME! + "=")
    //   ); // 👈 change to your cookie name
    const hasAuthCookie = Cookies.get(
      import.meta.env.VITE_PUBLIC_SUNSTAR_GUM_COOKIE_NAME!
    ); // using js-cookie to get cookie

    if (!hasAuthCookie) {
      navigate("/auth/login"); // redirect if cookie not found
    } else {
      const origin_url =
        document.referrer || import.meta.env.VITE_PUBLIC_SUNSTAR_GUM_URL;
      //   navigate("/dashboard"); // or redirect to app if authenticated
      if (origin_url !== window.location.href) {
        window.location.href = origin_url; // redirect to the original URL
      }
    }
  }, [navigate]);

  return null; // optional: show loading spinner or message
};

export default CookieRedirect;
